import { Component } from '@angular/core';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrl: './status.component.scss',
    standalone: false
})
export class StatusComponent {

}
